import React, { Component } from 'react';
import { Tab } from 'semantic-ui-react';

import GuaranteePurchases from './GuaranteePurchases';
import CancelledGuaranteePurchases from './CancelledGuaranteePurchases';

class GuaranteePurchasesTabs extends Component {
  render() {
    const panes = [
      {
        menuItem: 'Guarantee Purchases',
        render: () => (
          <Tab.Pane>
            {' '}
            <GuaranteePurchases />
          </Tab.Pane>
        ),
      },
      {
        menuItem: 'Canceled Purchases',
        render: () => (
          <Tab.Pane>
            <CancelledGuaranteePurchases />
          </Tab.Pane>
        ),
      },
    ];

    return (
      <div>
        {' '}
        <Tab panes={panes} />
      </div>
    );
  }
}

export default GuaranteePurchasesTabs;
